import { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
  children: ReactNode;
  gap: string;
}

const MasonryNative = ({ children, gap }: Props) => {
  const className = classnames({
    'col-count-1': true,
    'md:col-count-2': true,
    'xl:col-count-3': true,
    'gap-3': gap === 'normal',
    'gap-2': gap === 'small',
  });

  return <div className={className}>{children}</div>;
};

export default MasonryNative;
